import { render, staticRenderFns } from "./ColorizableAreasSimpleTable.vue?vue&type=template&id=216ccc01&scoped=true&"
import script from "./ColorizableAreasSimpleTable.vue?vue&type=script&lang=ts&"
export * from "./ColorizableAreasSimpleTable.vue?vue&type=script&lang=ts&"
import style0 from "./ColorizableAreasSimpleTable.vue?vue&type=style&index=0&id=216ccc01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216ccc01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSelect,VSimpleTable,VTooltip})
